/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this
 * file in accordance with the terms of the Adobe license agreement
 * accompanying it.
 *******************************************************************/

import { PLACE_NEGOTIABLE_QUOTE_ORDER_FRAGMENT } from '@/order/api/graphql/PlaceNegotiableQuoteOrderFragment.graphql';

export const PLACE_NEGOTIABLE_QUOTE_ORDER_MUTATION = /* GraphQL */ `
  mutation PLACE_NEGOTIABLE_QUOTE_ORDER_MUTATION($quoteUid: ID!) {
    placeNegotiableQuoteOrder(input: { quote_uid: $quoteUid }) {
      ...PLACE_NEGOTIABLE_QUOTE_ORDER_FRAGMENT
    }
  }

  ${PLACE_NEGOTIABLE_QUOTE_ORDER_FRAGMENT}
`;
